// AppContext.tsx
import React, { createContext, ReactNode, useContext, useState, useRef, useEffect, useCallback } from "react";
import { LoggedInUser } from "../types/models/loggeduser";
import { useMediaQuery } from "@mui/material"; // Optional: if using Material-UI

import defaultImage from "../assets/images/default_user.jpg";
interface AppContextType {
  theme: string;
  setTheme: (theme: string) => void;
  loggedinuser: LoggedInUser;
  setLoggedinuser: (user: LoggedInUser) => void;
  isLoginCalledRef: React.MutableRefObject<boolean>;
  authChecked: boolean;
  setAuthChecked: (checked: boolean) => void;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarCollapsed: boolean;
  showSidebar: boolean;
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSidebar: () => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  
  const storedUser = localStorage.getItem("loggedinuser");
  const user: LoggedInUser = storedUser ? JSON.parse(storedUser) : {
    id: '',
    displayName: '',
    mail: '',
    profileImage: defaultImage,
    roleId: [],
    Token: '',
    roles: '',
    companyId: ''
  };

  const [theme, setTheme] = useState<string>("light");
  const [loggedinuser, setLoggedinuser] = useState<LoggedInUser>(user);
  const [showSidebar, setShowSidebar] = useState(false);
  const isLoginCalledRef = useRef(false);
  const [authChecked, setAuthChecked] = useState(false);

  const [sidebarCollapsed, setIsCollapsed] =  useState(() =>(
    typeof window !== 'undefined' ? window.innerWidth <= 990 : false
  ));

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      const shouldCollapse = window.innerWidth <= 990;
      setIsCollapsed(shouldCollapse);
      
      if (!shouldCollapse && showSidebar) {
        setShowSidebar(false);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [showSidebar]);

  // Toggle function for manual control
  const toggleSidebar = () => {
    if (window.innerWidth <= 990) {
      setShowSidebar(prev => !prev);
    } else {
      setIsCollapsed(prev => !prev);
    }
  };

  return (
    <AppContext.Provider value={{
      theme,
      setTheme,
      loggedinuser,
      setLoggedinuser,
      authChecked,
      setAuthChecked,
      isLoginCalledRef,
      sidebarCollapsed,
      setIsCollapsed,
      showSidebar,
      setShowSidebar,
      toggleSidebar
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

// const useTraceableState = <T,>(initialValue: T): [T, (value: T | ((prevState: T) => T)) => void] => {
//   const [state, setState] = useState(initialValue);
  
//   const setTraceableState = useCallback((value: T | ((prevState: T) => T)) => {
//     if (typeof value === 'function') {
//       setState(prev => {
//         const newValue = (value as (prevState: T) => T)(prev);
//         console.log(`State changed from ${prev} to ${newValue}`);
//         console.trace('Change origin');
//         return newValue;
//       });
//     } else {
//       console.log(`State changed from ${state} to ${value}`);
//       console.trace('Change origin');
//       setState(value);
//     }
//   }, [state]);
  
//   return [state, setTraceableState];
// };